import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'core/store/Store';

export interface Coordinates {
  latitude: number;
  longitude: number;
}

export interface MapState {
  zoomLevel: number;
  coordinates: Coordinates | undefined;
  showDeliveriesRoute: boolean;
  showStopsRoute: boolean;
  showCourierRoute: boolean;
  showMicrozones: boolean;
}

const initialState: MapState = {
  zoomLevel: 6,
  coordinates: undefined,
  showDeliveriesRoute: false,
  showStopsRoute: false,
  showCourierRoute: true,
  showMicrozones: true
};

export const mapSlice = createSlice({
  name: 'mapSlice',
  initialState,
  reducers: {
    setZoomLevel: (state, action: PayloadAction<number>) => ({
      ...state,
      zoomLevel: action.payload,
    }),
    setCoordinates: (state, action: PayloadAction<Coordinates>) => ({
      ...state,
      coordinates: action.payload,
    }),
    setShowDeliveriesRoutes: (state, action: PayloadAction<boolean>) => ({
      ...state,
      showDeliveriesRoute: action.payload,
    }),
    setshowStopsRoute: (state, action: PayloadAction<boolean>) => ({
      ...state,
      showStopsRoute: action.payload,
    }),
    setShowCourierRoute: (state, action: PayloadAction<boolean>) => ({
      ...state,
      showCourierRoute: action.payload,
    }),
    setShowMicrozones: (state, action: PayloadAction<boolean>) => ({
      ...state,
      showMicrozones: action.payload,
    })
  },
});

export const selectZoomLevel = (state: RootState) => state.mapReducer.zoomLevel;
export const selectCoordinates = (state: RootState) =>
  state.mapReducer.coordinates;
export const selectShowDeliveriesRoute = (state: RootState) =>
  state.mapReducer.showDeliveriesRoute;
export const selectShowStopRoute = (state: RootState) =>
  state.mapReducer.showStopsRoute;
export const selectShowCourierRoute = (state: RootState) =>
  state.mapReducer.showCourierRoute;
export const selectShowMicrozones = (state: RootState) =>
  state.mapReducer.showMicrozones;
export const {
  setZoomLevel,
  setCoordinates,
  setShowDeliveriesRoutes,
  setshowStopsRoute,
  setShowCourierRoute,
  setShowMicrozones
} = mapSlice.actions;
export default mapSlice.reducer;
